const BASE = import.meta.env.VITE_API_URL || '';

const DEFAULT_TIMEOUT = 30000; // 30 seconds

async function fetchWithTimeout(
  url: string,
  init?: RequestInit,
  timeoutMs = DEFAULT_TIMEOUT
): Promise<Response> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch(url, {
      ...init,
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    return res;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error instanceof Error && error.name === 'AbortError') {
      throw new Error(`Request timeout after ${timeoutMs}ms`, { cause: error });
    }
    throw error;
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);

  if (init?.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  try {
    const res = await fetchWithTimeout(`${BASE}${path}`, { ...init, headers });
    
    if (!res.ok) {
      const errorText = await res.text().catch(() => `HTTP ${res.status}`);
      throw new Error(`API ${res.status}: ${errorText}`);
    }

    const payload = await res.json().catch(() => null);
    return payload as T;
  } catch (error) {
    console.error(`[API Error] ${path}:`, error);
    throw error;
  }
}
